import { gql, useQuery } from "@apollo/client";
import mainPermissionList from "src/layouts/AVC_Main/config/MainPermissionListConfig";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

//Schema definition
const Q_GetReal = gql`
  query getReal {
    getReal {
      firstName
      lastName
      nationalCode
    }
  }
`;

function useGetReal(skip) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_GetReal,
    requestConfig({ module: "AVC_PROFILE", skip: skip, Microservice: mainPermissionList.getReal })
  );
  return { data, error, loading };
}
export default useGetReal;

const Q_GetMeReal = gql`
  query getMeReal {
    me {
      id
      username
      profileId
      userType
      realLegal
    }
  }
`;

export function useGetMeReal(skip) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_GetMeReal,
    requestConfig({ module: "AVC_AAA", skip: skip, Microservice: mainPermissionList.me })
  );
  return { data, error, loading };
}
